import {Injectable} from '@angular/core';
import { FrontStationHttpService } from '../http/stationHttp.service';
import { IziviaError } from '../../domain/error/iziviaError';
import { IziviaLoggerService } from '../common/iziviaLogger.service';
import { StationDto } from '../../domain/infra/station/station';
import { UserAction } from '../../domain/infra/userAction';
import { IziviaToastService } from '../common/iziviaToast.service';
import {Observable, of, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {StationUtilsService} from '../utils/stationUtils.service';

@Injectable({
    providedIn: 'root'
})
export class StationSearcherService {

    constructor(private readonly toastService: IziviaToastService,
        private readonly loggerService: IziviaLoggerService,
        private readonly stationService: FrontStationHttpService,
        private readonly stationUtilsService: StationUtilsService) {
    }

    findByAlias(alias: string): Observable<StationDto> {
        return this.stationService.findByAlias(alias, this.stationUtilsService.newChargeStationLazyCategories)
            .pipe(
                catchError(error => {
                    if (error.status === 404) {
                        this.toastService.showError('station.error.aliasNotFound');
                    } else {
                        this.toastService.showError('error.default');
                    }

                    return throwError(error);
                }),
                switchMap(station => {
                    if (!station.currentUserActions || !station.currentUserActions.includes(UserAction.BUY_OTP)) {
                        this.toastService.showWarning('station.stationUnavailable');
                        return throwError(new IziviaError(`${UserAction.BUY_OTP} is not available on station ${station.alias}`,
                            true));
                    }

                    return of(station);
                })
            );
    }
}
